﻿$(document).ready(function () {
    var iframes = $('.iframeContainer');
    if (iframes.length > 0) {
        iframes.each(function (i, e) {
            var spinner = doSpinner(e.id, 'onload');
            $('#' + e.id).on('load', function () {
                stopSpinner(spinner, e.id);
            });
        });
    }
});

// iframe resizing event
window.addEventListener('message', function (event) {
    if (event.target.e) {
        var model = ParseJsonString(event.data);

        if (!model || !model.heightSetting || !model.resizeFrame || !model.sourceHref) {
            return;
        }

        var filteredFrames = $(event.target.e).toArray().filter(function (frame) {
            var frameSrc = frame.src.slice(0, frame.src.indexOf("?"));
            var modelSrc = model.sourceHref.slice(0, model.sourceHref.indexOf("?"));
            var modelOldSrc = null;
            if (model.oldSourceHref) {
                modelOldSrc = model.oldSourceHref.slice(0, model.oldSourceHref.indexOf("?"));
            }
            return frameSrc === modelSrc || frameSrc === modelOldSrc;
        });

        if (filteredFrames && filteredFrames[0]) {
            filteredFrames[0].style.height = model.heightSetting + 'px';
        }
    }
});